import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getHomepageDetails = () => {
  const url = API_URLS.homepage;
  return axiosClient.get(url);
};

export const getStickyLinks = () => {
  const url = API_URLS.stickyLinks;
  return axiosClient.get(url);
};
